import React, { Fragment, useEffect, useState } from 'react';
import Pagination from "react-js-pagination";
import API from "../Network/API";
import Nav from "../Component/Nav";
import Footer from "../Component/Footer";
import SideBar from "./partials/SideBar";

export default LearningHistory;

function LearningHistory() {
    const [history, setHistory] = useState([]);
    const [current_page, setCurrentPage] = useState([]);
    const [per_page, setPerPage] = useState([]);
    const [total_page, setTotalPage] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchData = async (pageNumber = 1) => {
        setLoading(true);
        API.get(`/learning-history?page=${pageNumber}`).then(response => {
            setHistory(response.data.data.history);
            setCurrentPage(response.data.data.current_page);
            setPerPage(response.data.data.per_page);
            setTotalPage(response.data.data.total_page);
            setLoading(false);
        })
    };
    useEffect(() => {
        fetchData();
    }, [])

    const scoreClass = (score) => {
        const value = Number(score) || 0;
        if (value >= 75) return "historyScore historyScore--high";
        if (value >= 40) return "historyScore historyScore--mid";
        return "historyScore historyScore--low";
    };

    return (
        <Fragment>
            <Nav />
            <div className="studentDashboard">
                <div className="padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-0 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                                <div className="DashboardSideBar ">
                                    <SideBar />
                                </div>
                            </div>
                            <div className="col-12 col-sm-8 col-md-9 col-lg-9 col-xl-9 col-xxl-9">
                                <div className="StudentDashboardContent">
                                    <div className="dashboardHeader">
                                        <span className="dashboardWelcome">Your progress</span>
                                        <h4 className="dashboardTitle">Learning History</h4>
                                    </div>

                                    <div className="historyCard">
                                        <div className="table-responsive">
                                            <table className="table historyTable align-middle mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Time</th>
                                                        <th>Level</th>
                                                        <th>Class</th>
                                                        <th>Exercise</th>
                                                        <th>Score</th>
                                                        <th className="text-center">Right</th>
                                                        <th className="text-center">Wrong</th>
                                                        <th>Since Learning</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {loading &&
                                                        [...Array(5)].map((_, i) => (
                                                            <tr key={`skeleton-${i}`} className="historySkeletonRow">
                                                                {[...Array(9)].map((__, j) => (
                                                                    <td key={j}><span className="historySkeleton" /></td>
                                                                ))}
                                                            </tr>
                                                        ))}

                                                    {!loading && history?.length > 0 && history.map((item) => (
                                                        <tr key={item?.id}>
                                                            <td className="text-nowrap">{item?.date}</td>
                                                            <td className="text-nowrap">{item?.time}</td>
                                                            <td>{item?.level}</td>
                                                            <td>{item?.class}</td>
                                                            <td>{item?.exercise}</td>
                                                            <td>
                                                                <span className={scoreClass(item?.score)}>{item?.score}%</span>
                                                            </td>
                                                            <td className="text-center">
                                                                <span className="historyPill historyPill--right">{item?.right_answer}</span>
                                                            </td>
                                                            <td className="text-center">
                                                                <span className="historyPill historyPill--wrong">{item?.wrong_answer}</span>
                                                            </td>
                                                            <td className="text-nowrap">{item?.since}</td>
                                                        </tr>
                                                    ))}

                                                    {!loading && (!history || history.length === 0) && (
                                                        <tr>
                                                            <td colSpan="9" className="p-0">
                                                                <div className="emptyState emptyState--sm">
                                                                    <i className="fas fa-history" />
                                                                    <p>No learning history yet.</p>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    {total_page > 20 ?
                                        <div className="historyPagination">
                                            <Pagination
                                                activePage={current_page ? current_page : 0}
                                                itemsCountPerPage={per_page ? per_page : 0}
                                                totalItemsCount={total_page ? total_page : 0}
                                                onChange={(pageNumber) => {
                                                    fetchData(pageNumber)
                                                }}
                                                pageRangeDisplayed={8}
                                                itemClass="page-item"
                                                linkClass="page-link"
                                                firstPageText="First Page"
                                                lastPageText="Last Lage"
                                            />
                                        </div>
                                        : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </Fragment>
    );
}
